module.exports = __webpack_public_path__ + "media/bootstrap-icons/card-heading-3e623f56.svg";